import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../styles/Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
  hideHeader?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideFooter = false, hideHeader = false }) => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup';
  const isCanvasChat = location.pathname.includes('/apps/canvas-chat');
  const shouldHideFooter = hideFooter || isCanvasChat;
  const shouldHideHeader = hideHeader || isAuthPage;

  return (
    <div className={`layout ${shouldHideHeader ? 'layout-no-header' : ''}`}>
      {!shouldHideHeader && <Header />}
      <main className="main-content">
        {children}
      </main>
      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default Layout; 